import React, { useState } from 'react';
import { Box, Button, Typography, Paper } from '@mui/material';
import BaseRound from './BaseRound';
import { useGame } from '../../contexts/GameContext';

const categories = [
    {
      name: 'Automarken',
      description: 'Zählt reihum Automarken auf (oder wählt ein anderes Thema). Wer einen Fehler macht oder zu lange zögert, trinkt 2 Schlücke!'
    },
    {
      name: 'Länder',
      description: 'Zählt reihum Länder auf (oder wählt ein anderes Thema). Wer einen Fehler macht oder zu lange zögert, trinkt 2 Schlücke!'
    },
    {
      name: 'Biere',
      description: 'Zählt reihum Biersorten oder -marken auf (oder wählt ein anderes Thema). Wer einen Fehler macht oder zu lange zögert, trinkt 2 Schlücke!'
    },
    {
      name: 'Städte',
      description: 'Zählt reihum deutsche Städte auf (oder wählt ein anderes Thema). Wer einen Fehler macht oder zu lange zögert, trinkt 2 Schlücke!'
    },
    {
      name: 'Sportarten',
      description: 'Zählt reihum Sportarten auf (oder wählt ein anderes Thema). Wer einen Fehler macht oder zu lange zögert, trinkt 2 Schlücke!'
    },
    {
      name: 'Filmklassiker',
      description: 'Zählt reihum bekannte Filme auf (oder wählt ein anderes Thema). Wer einen Fehler macht oder zu lange zögert, trinkt 2 Schlücke!'
    },
    {
      name: 'Musikgenres',
      description: 'Zählt reihum Musikgenres auf (oder wählt ein anderes Thema). Wer einen Fehler macht oder zu lange zögert, trinkt 2 Schlücke!'
    },
    {
      name: 'Serien',
      description: 'Zählt reihum bekannte Serien auf (oder wählt ein anderes Thema). Wer einen Fehler macht oder zu lange zögert, trinkt 2 Schlücke!'
    },
    {
      name: 'Fast-Food-Ketten',
      description: 'Zählt reihum Fast-Food-Ketten auf (oder wählt ein anderes Thema). Wer einen Fehler macht oder zu lange zögert, trinkt 2 Schlücke!'
    },
    {
      name: 'Cocktails',
      description: 'Zählt reihum Cocktail-Namen auf (oder wählt ein anderes Thema). Wer einen Fehler macht oder zu lange zögert, trinkt 2 Schlücke!'
    },
    {
      name: 'Superhelden',
      description: 'Zählt reihum Superhelden auf (oder wählt ein anderes Thema). Wer einen Fehler macht oder zu lange zögert, trinkt 2 Schlücke!'
    },
    {
      name: 'Berufe',
      description: 'Zählt reihum verschiedene Berufe auf (oder wählt ein anderes Thema). Wer einen Fehler macht oder zu lange zögert, trinkt 2 Schlücke!'
    }
  ];
  
  const rhymeWords = [
    {
      word: 'Haus',
      description: 'Findet reihum Reime auf "Haus" (oder wählt ein anderes Wort). Wer einen Fehler macht oder zu lange zögert, trinkt 2 Schlücke!'
    },
    {
      word: 'Wein',
      description: 'Findet reihum Reime auf "Wein" (oder wählt ein anderes Wort). Wer einen Fehler macht oder zu lange zögert, trinkt 2 Schlücke!'
    },
    {
      word: 'Bier',
      description: 'Findet reihum Reime auf "Bier" (oder wählt ein anderes Wort). Wer einen Fehler macht oder zu lange zögert, trinkt 2 Schlücke!'
    },
    {
      word: 'Nacht',
      description: 'Findet reihum Reime auf "Nacht" (oder wählt ein anderes Wort). Wer einen Fehler macht oder zu lange zögert, trinkt 2 Schlücke!'
    },
    {
      word: 'Feuer',
      description: 'Findet reihum Reime auf "Feuer" (oder wählt ein anderes Wort). Wer einen Fehler macht oder zu lange zögert, trinkt 2 Schlücke!'
    },
    {
      word: 'Licht',
      description: 'Findet reihum Reime auf "Licht" (oder wählt ein anderes Wort). Wer einen Fehler macht oder zu lange zögert, trinkt 2 Schlücke!'
    },
    {
      word: 'Glas',
      description: 'Findet reihum Reime auf "Glas" (oder wählt ein anderes Wort). Wer einen Fehler macht oder zu lange zögert, trinkt 2 Schlücke!'
    },
    {
      word: 'Zeit',
      description: 'Findet reihum Reime auf "Zeit" (oder wählt ein anderes Wort). Wer einen Fehler macht oder zu lange zögert, trinkt 2 Schlücke!'
    },
    {
      word: 'Sonne',
      description: 'Findet reihum Reime auf "Sonne" (oder wählt ein anderes Wort). Wer einen Fehler macht oder zu lange zögert, trinkt 2 Schlücke!'
    },
    {
      word: 'Meer',
      description: 'Findet reihum Reime auf "Meer" (oder wählt ein anderes Wort). Wer einen Fehler macht oder zu lange zögert, trinkt 2 Schlücke!'
    }
  ];
  

export default function AufzaehlungRound() {
  const { state, nextRound } = useGame();
  const [isRhymeMode] = useState(Math.random() < 0.5);
  const [selectedItem] = useState(() => {
    if (isRhymeMode) {
      return rhymeWords[Math.floor(Math.random() * rhymeWords.length)];
    } else {
      return categories[Math.floor(Math.random() * categories.length)];
    }
  });

  return (
    <BaseRound
      instructions={`${state.activePlayer} beginnt! ${selectedItem.description}`}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Paper sx={{ p: 3, bgcolor: 'background.paper' }}>
          <Typography variant="h5" align="center">
            {isRhymeMode ? `Reimwort: "${selectedItem.word}"` : `Kategorie: ${selectedItem.name}`}
          </Typography>
        </Paper>
        
        <Button 
          variant="contained" 
          color="primary"
          onClick={nextRound}
          sx={{ mt: 2 }}
        >
          Runde Beenden
        </Button>
      </Box>
    </BaseRound>
  );
} 